<template>
	<div>
		<aeg-case-home
			:caseViews="caseViews"
			addProposalButtonText="Add Jewellers Tour Proposal"
			productTypeLabel="Type"
			selectProductInsuranceType="jewellers_tour"
		></aeg-case-home>
	</div>
</template>

<script>
import AegCaseHome from "./AegCaseHome"

export default {
	components: {
		AegCaseHome
	},
	data() {
		return {
			caseViews: {
				jewellers_tour_primary_layer: "AegCaseJewellersTour"
			}
		}
	}
}
</script>
